import { render, staticRenderFns } from "./NotificationSnack.vue?vue&type=template&id=ae54e540&scoped=true&"
import script from "./NotificationSnack.vue?vue&type=script&lang=js&"
export * from "./NotificationSnack.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSnack.vue?vue&type=style&index=0&id=ae54e540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae54e540",
  null
  
)

export default component.exports